import {svgIconWrapper} from '../svg-icon-wrapper';

import KrispcallRegular from './krispcall-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <KrispcallRegular {...props} />;
}

SvgComponent.iconName = 'krispcallRegular';

export const KrispcallRegularIcon = svgIconWrapper(SvgComponent);
